import SelectedGenreBtn from "./SelectedGenreBtn"


export default function SelectedDetails(props){
    return(
        <div className="selected-details-container">
            <img src={props.picture} alt={props.movieName}/>
            <div className="details-container">
                <h1>{props.movieName}</h1>
                <h2>{'"'+props.tagline+'"'}</h2>
                <p>{props.desc}</p>
                <h1>Ratings : {props.ratings} </h1>
                <div className="genre-container">
                    {
                        props.genres.map((e)=>{
                           return <SelectedGenreBtn key={ e.name+e.name} genre={e.name} />
                        })
                    }
                </div>
                <a className="trailer" href={"https://www.youtube.com/watch?v="+props.trailer}>Watch Trailer
                    <div className="circle">
                        <div className="triangle-right"></div>
                    </div>
                </a>
            </div>
        </div>
    )
}